import React from "react";
import { ContainerFW, Container } from "../global";
export const SectionHeader = (props) => (React.createElement(ContainerFW, null,
    React.createElement("div", { className: "largeImageSection" },
        React.createElement(Container, null,
            props.title && React.createElement("h2", null, props.title),
            props.subtitle && React.createElement("p", null, props.subtitle)))));
